/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passkey_Setup_SafetyInputs */



/**
* | output |
* | --- |
* | "Passkeys are significantly safer than email login, because email is not encrypted." |
*
* @param {Auth_Passkey_Setup_SafetyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_passkey_setup_safety = /** @type {((inputs?: Auth_Passkey_Setup_SafetyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passkey_Setup_SafetyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkeys sind deutlich sicherer als die Anmeldung per E-Mail, da E-Mails nicht verschlüsselt sind.")
	return /** @type {LocalizedString} */ ("Passkeys are significantly safer than email login, because email is not encrypted.")
});